import { Configuration } from './Configuration';
import ConnectableSlots from './ConnectableSlots';
import { LineSlotMovement } from './Direction';
import { Notification } from './Notification';
import { ValidationError } from './Validation';

export interface SelectedArticle {
  id: string;
  connectableSlots?: ConnectableSlots[];
  lineSlotMovements?: LineSlotMovement[];
  heightControlPanelMovements?: LineSlotMovement[];
}

export interface Rights {
  readonly edit: boolean;
  readonly request: boolean;
}

export default class Store {
  static empty(): Store {
    return new Store(undefined, { edit: false, request: false }, undefined, [], [], []);
  }

  constructor(
    configuration: Configuration,
    rights: Rights,
    selectedArticle: SelectedArticle | undefined,
    suppressInteractions: string[],
    notifications: Notification[],
    validationErrors: ValidationError[],
  ) {
    this.configuration = configuration;
    this.rights = rights;
    this.selectedArticle = selectedArticle;
    this.suppressInteractions = suppressInteractions;
    this.notifications = notifications;
    this.validationErrors = validationErrors;
  }

  configuration: Configuration;
  rights: Rights;
  selectedArticle: SelectedArticle | undefined;
  suppressInteractions: string[];
  notifications: Notification[];
  validationErrors: ValidationError[];
}
export const isSuppressInteractions = (store: Store) => {
  return store.suppressInteractions.length > 0;
};
